import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Auto-update composable: calls the given callback every `intervalMs`
 * when the browser tab is visible. Pauses when hidden.
 */
export function useAutoUpdate(callback: () => Promise<void>, intervalMs = 10_000) {
  const active = ref(true)
  let timer: ReturnType<typeof setInterval> | null = null

  function start() {
    if (timer) return
    timer = setInterval(async () => {
      if (active.value) {
        await callback()
      }
    }, intervalMs)
  }

  function stop() {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  function onVisibility() {
    active.value = !document.hidden
    if (active.value && !timer) {
      start()
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', onVisibility)
    start()
  })

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', onVisibility)
    stop()
  })

  return { active }
}
